/**
 * HLF Global Countdown Timer
 * Single timer drives all countdown instances on the page.
 * Reads end-date from data attributes set by Liquid.
 */
(function () {
  'use strict';

  var IST_OFFSET_MS = 5.5 * 60 * 60 * 1000;

  function tonightMidnightUTC() {
    var nowIST = new Date(Date.now() + IST_OFFSET_MS);
    var tomorrowIST = new Date(Date.UTC(
      nowIST.getUTCFullYear(),
      nowIST.getUTCMonth(),
      nowIST.getUTCDate() + 1
    ));
    return tomorrowIST.getTime() - IST_OFFSET_MS;
  }

  function parseFinalCutoff(dateStr) {
    if (!dateStr) return 0;
    var p = dateStr.match(/(\d{4})-(\d{2})-(\d{2})/);
    if (!p) return 0;
    return Date.UTC(+p[1], +p[2] - 1, +p[3] + 1) - IST_OFFSET_MS;
  }

  function pad(n) { return String(n).padStart(2, '0'); }

  function updateElement(el, hours, minutes, seconds) {
    var style = el.getAttribute('data-countdown-style');

    if (style === 'strip') {
      updateStripElement(el, hours, minutes, seconds);
    } else if (style === 'card') {
      updateCardElement(el, hours, minutes, seconds);
    } else {
      updateCompactElement(el, hours, minutes, seconds);
    }
  }

  /* ── Strip style (Deal of the Day) ── */
  function updateStripElement(el, h, m, s) {
    var hEl = el.querySelector('[data-unit="hours"]');
    var mEl = el.querySelector('[data-unit="minutes"]');
    var sEl = el.querySelector('[data-unit="seconds"]');
    if (hEl) setDigits(hEl, h);
    if (mEl) setDigits(mEl, m);
    if (sEl) setDigits(sEl, s);
  }

  function setDigits(container, val) {
    var digits = pad(val).split('');
    var spans = container.querySelectorAll('.hlf-cd-digit');
    digits.forEach(function (d, i) {
      if (spans[i] && spans[i].textContent !== d) {
        spans[i].textContent = d;
        spans[i].classList.remove('hlf-cd-pop');
        void spans[i].offsetWidth;
        spans[i].classList.add('hlf-cd-pop');
      }
    });
  }

  /* ── Card style (Flavour of the Day) ── */
  function updateCardElement(el, h, m, s) {
    setFlip(el.querySelector('[data-unit="hours"]'), h);
    setFlip(el.querySelector('[data-unit="minutes"]'), m);
    setFlip(el.querySelector('[data-unit="seconds"]'), s);
  }

  function setFlip(el, val) {
    if (!el) return;
    var str = pad(val);
    if (el.textContent !== str) {
      el.classList.remove('hlf-cd-flip');
      void el.offsetWidth;
      el.textContent = str;
      el.classList.add('hlf-cd-flip');
    }
  }

  /* ── Compact style (product cards) ── */
  function updateCompactElement(el, h, m, s) {
    var hEl = el.querySelector('[data-unit="hours"]');
    var mEl = el.querySelector('[data-unit="minutes"]');
    var sEl = el.querySelector('[data-unit="seconds"]');
    if (hEl) hEl.textContent = pad(h);
    if (mEl) mEl.textContent = pad(m);
    if (sEl) sEl.textContent = pad(s);
  }

  /* ── Main tick — drives all instances ── */
  function tick() {
    var elements = document.querySelectorAll('.hlf-countdown[data-end-date]');
    if (!elements.length) return;

    var now = Date.now();

    elements.forEach(function (el) {
      var endDate = el.getAttribute('data-end-date');
      var finalCutoff = parseFinalCutoff(endDate);

      // Auto-extend: If the sale end date has passed but the countdown setting is still enabled
      // in the admin panel, auto-extend the countdown to tonight's midnight to maintain urgency
      // and prevent showing broken '00:00:00' elements to users.
      var target = tonightMidnightUTC();
      var diff = target - now;

      if (diff <= 0) {
        updateElement(el, 0, 0, 0);
        return;
      }

      var hours = Math.floor(diff / 3600000);
      var minutes = Math.floor((diff % 3600000) / 60000);
      var seconds = Math.floor((diff % 60000) / 1000);

      updateElement(el, hours, minutes, seconds);
    });
  }

  function init() {
    tick();
    setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
